import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/id/danger/page';

export const Route = createFileRoute('/_app/_chat/skills/$id/danger/')({
  component: Page,
});
